// @core/api/endpoints/landing/delete_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/landing';

/**
 * Delete landing page
 * Deletes a landing page and all its sections.
 */
export async function DeleteLandingPage(
  page_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
